import Image from 'next/image';
import styles from './footer.module.scss';
import { PATH } from 'data';
import Link from 'next/link';
import logo from 'assets/images/logo-small.png';
import { FaFacebookF, FaTelegramPlane, FaTwitter, FaYoutube } from 'react-icons/fa';
import { COLORS } from 'utilities';
import { RiWhatsappFill } from 'react-icons/ri';
import Mojavez from 'assets/images/leagals/mojavez-ir.svg';
import IranianAsnaf from 'assets/images/leagals/iranianasnaf';

export default function FooterComp() {
    return (
        <footer className={`${styles['footer']} d-pre-md-none`}>
            <div className="flex-column h-100 main-content">
                <div className={`${styles['top-section']} d-flex center-content-y justify-content-between`}>
                    <div className="g-lg-5 g-pre-lg-3 center-content-y">
                        <Link href={PATH.home} className="align-items-center g-1">
                            <Image src={logo} alt="تیک سبز" width={77} height={77} />
                        </Link>
                        <div className="center-content-y g-lg-4 g-pre-lg-2">
                            <Link href={PATH.aboutUs} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">درباره ما</p>
                            </Link>
                            <Link href={PATH.contactUs} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">تماس با ما</p>
                            </Link>
                            <Link href={PATH.terms} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">قوانین و مقررات</p>
                            </Link>
                            <Link href={PATH.panel.tickets.new()} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">ثبت درخواست پشتیبانی</p>
                            </Link>
                            <Link href={PATH.download} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">دریافت اپلیکیشن</p>
                            </Link>
                        </div>
                    </div>
                    <div className="d-flex g-3 center-content">
                        <div className={`${styles['service']}`}>
                            <a
                                style={{ width: '100%', height: '100%', display: 'flex' }}
                                referrerPolicy="origin"
                                target="_blank"
                                href="https://trustseal.enamad.ir/?id=735735&Code=Xhki7ddrJyuZZ9Kcb0Mf0bIn1hY2JmbU"
                            >
                                <img
                                    {...{ code: 'Xhki7ddrJyuZZ9Kcb0Mf0bIn1hY2JmbU' }}
                                    referrerPolicy="origin"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=735735&Code=Xhki7ddrJyuZZ9Kcb0Mf0bIn1hY2JmbU"
                                    alt=""
                                    style={{ cursor: 'pointer' }}
                                />
                            </a>
                        </div>
                        <div className={`${styles['service']} d-none`}>
                            <a href="https://apinovin.iranianasnaf.ir/parvaneh/7b5ae770-4486-4f9d-ac8a-5348977da78b/html">
                                <img
                                    src={IranianAsnaf}
                                    alt="Iranian Asnaf"
                                    style={{ width: '100%', height: '100%', display: 'flex' }}
                                />
                            </a>
                        </div>
                        <div className={`${styles['service']} d-none`}>
                            <a
                                href="https://qr.mojavez.ir/track/15658225"
                                style={{ width: '100%', height: '100%', display: 'flex' }}
                            >
                                <Image src={Mojavez} alt="Mojavez" />
                            </a>
                        </div>
                        {/* <div className={`${styles['service']}`}></div>
                        <div className={`${styles['service']}`}></div> */}
                    </div>
                </div>
            </div>
            <div className={`${styles['bottom-section']}`}>
                <div className="main-content justify-content-between">
                    <p className="t-p1 t-400 t-l-black1 t-d-gray3">
                        کلیه حقوق این سایت متعلق به <span className="t-l-primary t-d-primary">تیک سبز</span> است.
                    </p>
                    <div className="g-3 center-content-y">
                        <FaFacebookF color={COLORS.primary} size={24} />
                        <FaTelegramPlane color={COLORS.primary} size={24} />
                        <FaTwitter color={COLORS.primary} size={24} />
                        <RiWhatsappFill color={COLORS.primary} size={24} />
                        <FaYoutube color={COLORS.primary} size={24} />
                    </div>
                </div>
            </div>
        </footer>
    );
}
